import instaReply from './insta-reply'
import instaPoster from './insta-poster'

const items = [
  ...instaReply,
  ...instaPoster,
]
export default items.map(item => ({ ...item, instagram: true }))
